module.exports = __webpack_public_path__ + "img/03-bk-city-mountains.e6bf5bfd.svg";